var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeafB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 488.322,
    height: 523.48,
    viewBox: "0 0 488.322 523.48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "leaf 6",
    d: "M195.67 71.8161C226.676 74.3109 230.813 0 230.813 0C230.813 0 243.699 90.0517 276.38 77.5015C295.664 70.0959 305.567 33.2149 305.567 33.2149C302.892 103.447 288.041 208.236 298.717 213.054C309.392 217.873 335.945 172.957 335.945 172.957L374.066 107.126C374.066 107.126 377.342 123.284 383.894 128.371C390.446 133.458 466.093 107.126 466.093 107.126C466.093 107.126 431.248 167.272 454.18 172.957C477.113 178.642 488.132 172.957 488.132 172.957C492.326 175.327 425.589 244.175 425.589 244.175C425.589 244.175 361.263 282.587 343.707 292.273C360.679 289.325 409.841 318.768 399.679 324.07C399.679 324.07 364.238 319.582 362.749 324.07C361.26 328.559 402.061 361.773 402.061 361.773C402.061 361.773 348.453 368.955 345.773 377.334C343.092 385.712 360.366 407.855 360.366 407.855C360.366 407.855 294.92 370.127 245.704 368.88C245.704 368.88 248.379 463.788 245.704 477.577C243.029 491.366 240.046 498.523 240.046 498.523C240.046 498.523 222.474 528.447 209.965 522.761C197.457 517.076 225.551 489.36 230.813 467.702C239.875 430.408 232.6 369.49 232.6 369.49C184.996 375.166 124.49 417.132 124.49 417.132C124.49 417.132 139.381 385.114 131.936 381.224C124.49 377.334 75.0515 387.807 75.0515 387.807C75.0515 387.807 102.451 345.914 100.962 340.229C99.473 334.543 70.5841 334.543 70.5841 334.543C70.5841 334.543 118.831 298.934 113.471 296.241C108.11 293.548 55.7582 269.635 31.2714 239.088C14.921 218.691 0 179.839 0 179.839C0 179.839 26.1917 188.575 38.4192 179.839C58.5622 165.448 18.7629 119.394 18.7629 119.394C18.7629 119.394 67.1652 160.444 89.9426 142.136C99.9911 134.059 106.323 113.41 106.323 113.41C120.087 162.068 135.01 186.929 173.631 227.118C176.766 154.921 173.08 114.504 158.442 42.4912C158.442 42.4912 177.255 70.3344 195.67 71.8161Z",
    fill: "url(#paint0_linear_0_58)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_58",
    x1: 244.161,
    y1: 0,
    x2: 244.161,
    y2: 523.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A35C45"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeafB);
export default __webpack_public_path__ + "static/media/leaf-b.7b3005867e6744b16ea8bfb48cec990b.svg";
export { ForwardRef as ReactComponent };